<template>
    <div class="ResponsiveGrid" :style="overwriteStyle ? overwriteStyle : gridDimensions">
        <slot />
    </div>
</template>

<style lang="less" type="text/less">
.ResponsiveGrid {
    display: grid;
}
</style>

<script type="text/babel">
import { combineLatest } from 'rxjs'
import { map } from 'rxjs/operators'
import HasSubscriptions from 'dashboard-js/mixins/HasSubscriptions'
import ResponsiveValue from 'dashboard-js/app/ResponsiveValue'

export default {
    mixins: [HasSubscriptions],

    props: ['columns', 'rows', 'gap', 'overwriteStyle'],

    data() {
        return {
            currentColumns: null,
            currentGap: [0, 0],
        }
    },

    computed: {
        gridDimensions() {
            return {
                gridTemplateColumns: `repeat(${this.currentColumns}, 1fr)`,
                gridRowGap: this.currentGap[0],
                gridColumnGap: this.currentGap[1],
            }
        },
    },

    created() {
        const [columns, rows, gap] = [
            ResponsiveValue.create(this.columns),
            ResponsiveValue.create(this.rows),
            ResponsiveValue.create(this.gap).pipe(map(this.normalizeGap)),
        ]

        this.subscribe(columns, value => (this.currentColumns = value))
        this.subscribe(gap, value => (this.currentGap = value))

        if (rows) {
            this.subscribe(
                combineLatest([columns, rows]).pipe(map(([_cols, _rows]) => _cols * _rows)),
                cells => this.$emit('preparedCells', cells)
            )
        }
    },

    methods: {
        normalizeGap(value) {
            return typeof value === 'string' ? [value, value] : value
        },
    },
}
</script>
